export default __webpack_public_path__ + "static/media/qMark.5c7bb2de.svg";